const DashboardPreviewIcon = (
  <svg
    width="380"
    height="260"
    viewBox="0 0 380 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="dashboardPreviewClip">
        <rect x="1" y="1" width="378" height="258" rx="20" />
      </clipPath>
    </defs>

    {/* Tarjeta */}
    <rect
      x="1"
      y="1"
      width="378"
      height="258"
      rx="20"
      fill="#FFFFFF"
      stroke="#E2E8F0"
      strokeWidth="1.5"
    />

    <g clipPath="url(#dashboardPreviewClip)">
      {/* Barra lateral */}
      <rect x="0" y="0" width="56" height="260" fill="#1C2434" />

      {/* Icono activo (código) */}
      <rect x="16" y="24" width="24" height="24" rx="7" fill="#3C50E0" />
      <path
        d="M24 30L20.5 36L24 42M32 30L35.5 36L32 42"
        stroke="#FFFFFF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Icono carpeta */}
      <rect
        x="16"
        y="68"
        width="24"
        height="24"
        rx="7"
        fill="#FFFFFF"
        fillOpacity="0.08"
      />
      <path
        d="M21 76h4l1.4 1.6H35a1 1 0 011 1V85a1 1 0 01-1 1H21a1 1 0 01-1-1v-9a1 1 0 011-1z"
        stroke="#FFFFFF"
        strokeOpacity="0.55"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />

      {/* Icono usuarios */}
      <rect
        x="16"
        y="112"
        width="24"
        height="24"
        rx="7"
        fill="#FFFFFF"
        fillOpacity="0.08"
      />
      <circle cx="25" cy="120" r="2.6" stroke="#FFFFFF" strokeOpacity="0.55" strokeWidth="1.3" />
      <circle cx="32" cy="121.5" r="2" stroke="#FFFFFF" strokeOpacity="0.55" strokeWidth="1.3" />
      <path
        d="M20 129c0-2.8 2.2-5 5-5s5 2.2 5 5M30 129c0-2-1.6-3.6-3.6-4"
        stroke="#FFFFFF"
        strokeOpacity="0.55"
        strokeWidth="1.3"
        strokeLinecap="round"
      />

      {/* Icono ajustes */}
      <rect
        x="16"
        y="156"
        width="24"
        height="24"
        rx="7"
        fill="#FFFFFF"
        fillOpacity="0.08"
      />
      <circle cx="28" cy="168" r="3.4" stroke="#FFFFFF" strokeOpacity="0.55" strokeWidth="1.3" />
      <path
        d="M28 161.6v1.4M28 173v1.4M34.4 168H33M23 168h-1.4M32.5 163.5l-1 1M24.5 172.5l-1 1M32.5 172.5l-1-1M24.5 163.5l-1-1"
        stroke="#FFFFFF"
        strokeOpacity="0.55"
        strokeWidth="1.3"
        strokeLinecap="round"
      />

      {/* Encabezado */}
      <rect x="76" y="28" width="140" height="10" rx="5" fill="#E2E8F0" />
      <rect x="76" y="46" width="90" height="8" rx="4" fill="#EFF2F7" />

      {/* Tarjeta de lista */}
      <rect
        x="76"
        y="76"
        width="150"
        height="92"
        rx="12"
        fill="#F7F9FC"
        stroke="#E2E8F0"
      />
      <rect x="92" y="94" width="70" height="8" rx="4" fill="#8A99AF" />
      <rect x="92" y="112" width="50" height="8" rx="4" fill="#3C50E0" fillOpacity="0.35" />
      <rect x="92" y="130" width="94" height="8" rx="4" fill="#F472B6" fillOpacity="0.35" />
      <rect x="92" y="148" width="60" height="8" rx="4" fill="#8A99AF" fillOpacity="0.5" />

      {/* Tarjeta de gráfico de línea */}
      <rect
        x="238"
        y="76"
        width="120"
        height="92"
        rx="12"
        fill="#F7F9FC"
        stroke="#E2E8F0"
      />
      <polyline
        points="252,150 268,130 284,140 300,110 316,120 332,95 348,105"
        fill="none"
        stroke="#3C50E0"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="348" cy="105" r="4" fill="#3C50E0" />

      {/* Tarjeta de dona */}
      <rect
        x="76"
        y="180"
        width="282"
        height="66"
        rx="12"
        fill="#F7F9FC"
        stroke="#E2E8F0"
      />
      <g transform="translate(112, 213)">
        <circle r="24" fill="none" stroke="#E2E8F0" strokeWidth="10" />
        <circle
          r="24"
          fill="none"
          stroke="#3C50E0"
          strokeWidth="10"
          strokeDasharray="70 150.8"
          strokeLinecap="round"
          transform="rotate(-90)"
        />
        <circle
          r="24"
          fill="none"
          stroke="#A78BFA"
          strokeWidth="10"
          strokeDasharray="45 150.8"
          strokeDashoffset="-70"
          strokeLinecap="round"
          transform="rotate(-90)"
        />
        <circle
          r="24"
          fill="none"
          stroke="#F472B6"
          strokeWidth="10"
          strokeDasharray="30 150.8"
          strokeDashoffset="-115"
          strokeLinecap="round"
          transform="rotate(-90)"
        />
      </g>
      <rect x="160" y="200" width="80" height="8" rx="4" fill="#8A99AF" />
      <rect x="160" y="216" width="140" height="8" rx="4" fill="#DEE4EE" />
      <rect x="160" y="232" width="60" height="8" rx="4" fill="#DEE4EE" />
    </g>
  </svg>
);

export default DashboardPreviewIcon;
